import { PostgreSQL, SQLDialect, sql } from "@codemirror/lang-sql";
import {
  defaultHighlightStyle,
  syntaxHighlighting,
} from "@codemirror/language";
import { Extension } from "@codemirror/state";
import { tagHighlighter, tags } from "@lezer/highlight";

import { doubleDollarAsString } from "./doubleDollarAsString";
import functions from "./functions.json";
import keywords from "./keywords.json";
import types from "./types.json";

export const FIREBOLT_KEYWORDS = keywords.join(" ");
export const FIREBOLT_TYPES = types.join(" ");
export const FIREBOLT_FUNCTIONS = functions.join(" ");

const functionHighlighter = tagHighlighter([
  { tag: tags.standard(tags.name), class: "ͼfn" },
]);

export const FIREBOLT_SQL_DIALECT = SQLDialect.define({
  ...PostgreSQL.spec,
  keywords: `${FIREBOLT_KEYWORDS}`,
  types: FIREBOLT_TYPES,
  builtin: FIREBOLT_FUNCTIONS,
});

export const buildFireboltSql = () =>
  sql({
    dialect: FIREBOLT_SQL_DIALECT,
  });

export const buildFireboltSqlExtensions = (): Extension[] => [
  buildFireboltSql(),
  syntaxHighlighting(defaultHighlightStyle),
  syntaxHighlighting(functionHighlighter),
  doubleDollarAsString,
];
